import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { isValidMobileShape } from "@/lib/contact-lead"
import { useTranslations } from "next-intl"

interface ContactMobileFieldProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any
  label?: string | null
  required?: boolean
}

const ContactMobileField = ({ form, label, required = true }: ContactMobileFieldProps) => {
  const t = useTranslations("ContactForm")
  const displayLabel = (label?.trim()) || t("mobile")

  return (
    <FormField
      control={form.control}
      name="mobile"
      rules={{
        required: required ? t("mobileRequired") : false,
        validate: (value) => {
          if (!value || !String(value).trim()) return required ? t("mobileRequired") : true
          if (!isValidMobileShape(String(value))) return t("mobileInvalid")
          return true
        },
      }}
      render={({ field }) => (
        <FormItem className="space-y-2">
          <FormLabel htmlFor="mobile">{displayLabel}</FormLabel>
          <FormControl>
            <Input
              id="mobile"
              type="tel"
              autoComplete="tel"
              className="glass-panel"
              aria-invalid={!!form.formState.errors.mobile}
              data-testid="contact-form-mobile"
              {...field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}

export default ContactMobileField
